import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CommunicationService {

  private uploadProgress = new Subject<number>();

  sendUploadProgress(progress: number) {
    this.uploadProgress.next(progress);
  }

  getUploadProgress() {
    return this.uploadProgress.asObservable();
  }

}
